import React, { useState } from 'react';
import { Input, InputGroup } from 'reactstrap';
import { CustomModal } from './CustomModal';
import { FaPlus } from 'react-icons/fa';
import i18n from '@/utils/i18n';

type SelectWithAddNewProps = {
  options: string[];
  setOptions: (options: string[]) => void;
  selected: string;
  setSelected: (selected: string) => void;
  disabled?: boolean;
};

const SelectWithAddNew = ({
  options,
  setOptions,
  selected,
  setSelected,
  disabled,
}: SelectWithAddNewProps) => {
  const [newOption, setNewOption] = useState('');
  const [modal, setModal] = useState(false);

  const toggleModal = () => setModal(!modal);

  const handleAddNew = () => {
    if (disabled) {
      return;
    }

    if (newOption.trim()) {
      const newOptions = [...options, newOption.trim()];
      setOptions(newOptions);
      setSelected(newOption.trim());
      setNewOption('');
      toggleModal();
    }
  };

  return (
    <div>
      <InputGroup>
        <Input
          type="select"
          value={selected || ''}
          disabled={disabled}
          onChange={(e) => {
            if (e.target.value === 'add_new') {
              setModal(true);
              return;
            }
            setSelected(e.target.value);
          }}
        >
          <option value="" disabled>
            {i18n.t('Common:selectOption')}
          </option>
          {options.map((option, idx) => (
            <option key={idx} value={option}>
              {option}
            </option>
          ))}
          <option value="add_new">{i18n.t('Common:addNew')}...</option>
        </Input>
      </InputGroup>

      <CustomModal
        acceptButtonAction={handleAddNew}
        acceptButtonDisabled={newOption.trim() === ''}
        acceptButtonIcon={<FaPlus />}
        acceptButtonText={i18n.t('Common:add')}
        body={
          <Input
            type="text"
            value={newOption}
            disabled={disabled}
            onChange={(e) => setNewOption(e.target.value)}
            placeholder={`${i18n.t('Common:enterNewOption')}`}
            autoFocus
          />
        }
        header={i18n.t('Common:addNew')}
        isOpen={modal}
        setIsOpen={setModal}
      />
    </div>
  );
};

export default SelectWithAddNew;
